var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 40 40",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.1 12v1c0 10.7-7.8 23-22.2 23-4.2 0-8.3-1.3-11.9-3.6.6.1 1.2.1 1.9.1 3.5 0 6.9-1.2 9.7-3.5-3.3-.1-6.3-2.3-7.3-5.6 1.2.2 2.4.2 3.5-.1-3.6-.7-6.2-4-6.3-7.9v-.1c1.1.6 2.3 1 3.5 1-3.4-2.4-4.4-7.1-2.4-10.8 4 5.1 9.8 8.1 16.1 8.4-.6-2.8.2-5.7 2.3-7.7 3.1-3.1 8.1-2.9 11 .4 1.7-.4 3.4-1 5-2-.6 1.8-1.9 3.4-3.5 4.4 1.5-.2 3.1-.6 4.5-1.3-1 1.7-2.4 3.1-3.9 4.3z",
    fill: "#fafafa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f582d40dae497a2c9a355126233103dd.svg";
export { ForwardRef as ReactComponent };